// src/lib/useSiteFlags.ts
import { useEffect, useState } from "react";

export type SiteFlags = {
  maintenance_enabled: boolean;
  maintenance_message?: string | null;
  updated_at?: string;
};

export function useSiteFlags() {
  const [flags, setFlags] = useState<SiteFlags | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const res = await fetch("/api/public/site-flags", {
          method: "GET",
          credentials: "include",
          headers: { Accept: "application/json" },
        });
        const data = await res.json().catch(() => ({}));

        if (cancelled) return;

        if (res.ok && data?.ok) setFlags(data.flags ?? null);
        else setFlags(null);
      } catch {
        if (!cancelled) setFlags(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return { flags, loading };
}
